import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Component, OnInit, Output, EventEmitter,Input } from '@angular/core';
import { MatChipInputEvent } from '@angular/material';
import { NotificationService,CONSTANT, GridDataSource, LoaderService, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { Aplicacion,Iapplication } from "../shared/aplicacion.model";
import { AplicacionService } from "../shared/aplicacion.service";

@Component({
	//moduleId: module.id,
	selector: 'app-aplicacion-new',
	templateUrl: 'aplicacion-new.component.html'
})
export class ApplicationNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;
  // @Input()  ID:number;

	formGroupNewApplication: FormGroup;
	msgSuccessInsert: string;
	msgErrorInsert: string;
  obligatorioMsg: string;
  aplicacion: Iapplication;
  maxLengthMsg: string;
  applicationName: string ;
	nomApplicationMaxLength: number;
	descripcionMaxLength: number;
	nomApplicationPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
	// titlePage: string;
  buttonGroup: any;

  constructor(    private loaderService: LoaderService,
    private aplicacionService: AplicacionService,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    public fb :FormBuilder){}

    ngOnInit(){
    this.aplicacion = new Aplicacion(0,"","","","",true,"admin","","admin","");
		this.msgSuccessInsert = 'Se registró satisfactoriamente';
		this.msgErrorInsert = 'Error al registrar Aplicacion';
		this.titlePage = 'Completa los datos del Aplicacion';
		this.obligatorioMsg = 'Campo Obligatorio';
		this.maxLengthMsg = 'El tamaño máximo es de ';
		this.nomApplicationMaxLength = 100;
		this.descripcionMaxLength = 250;
		this.buttonGroup = [
			{ tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
		];

		this.setValuesFormBuilder();
    }

    private setValuesFormBuilder(){
      this.formGroupNewApplication = this.fb.group({
        nameApplication:['', Validators.compose([
          Validators.required,
          Validators.maxLength(this.nomApplicationMaxLength),
          CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
        description:['', Validators.compose([
          Validators.required,
          Validators.maxLength(this.descripcionMaxLength),
          CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      path:['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      icono:['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      });
    }
    changeEvent(aplicacion: Iapplication) {
      this.data = { aplicacion: { ID: aplicacion.ID, Name: aplicacion.Name } };
      this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    }

    formGroupNewAplicacionSubmit(event) {
      if (this.formGroupNewApplication.invalid)
        return;

      this.aplicacion.Name = event.value.nameApplication;
      this.aplicacion.Path=event.value.path;
      this.aplicacion.Icono=event.value.icono
      this.aplicacion.Description = event.value.description;
      this.aplicacion.Status = event.value.Status;

      this.insertarApplication(this.aplicacion);
    }

    private insertarApplication(aplicacion:Iapplication) {
      this.loaderService.show();
      this.aplicacion.Status = CONSTANT.estadoRegistro.activo; //por defecto es activo
      this.aplicacionService.insertarApplication(aplicacion)

      .subscribe(res => {
        // if (this.errorService.getResultMessageError2(res)) {
          aplicacion.ID=res;
          this.changeEvent(aplicacion);
          this.notificationService.successful("Se grabo satisfactoriamente" );
        // }
      },
      error => {
        this.notificationService.error(this.msgErrorInsert);
        throw error;
      },
      () => {
        this.loaderService.hide();
      });
    }
  }
